(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2evKT", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1a05858528f80b13$export$6503ec6e8aabbaf; }, function (v) { return $1a05858528f80b13$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $1a05858528f80b13$export$f7ad0328861e2f03; }, function (v) { return $1a05858528f80b13$export$f7ad0328861e2f03 = v; });
var $1a05858528f80b13$export$6503ec6e8aabbaf;
var $1a05858528f80b13$export$f7ad0328861e2f03;
"use strict";
var $1a05858528f80b13$var$mapping = new Map();
function $1a05858528f80b13$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$1a05858528f80b13$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $1a05858528f80b13$var$resolve(id) {
    var resolved = $1a05858528f80b13$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$1a05858528f80b13$export$6503ec6e8aabbaf = $1a05858528f80b13$var$register;
$1a05858528f80b13$export$f7ad0328861e2f03 = $1a05858528f80b13$var$resolve;

});

parcelRegister("f6OTe", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $affee43d05afb4fc$export$bdfd709ae4826697; }, function (v) { return $affee43d05afb4fc$export$bdfd709ae4826697 = v; });
var $affee43d05afb4fc$export$bdfd709ae4826697;
var $affee43d05afb4fc$export$c9e73fbda7da57b6;
var $affee43d05afb4fc$export$5a759dc7a1cfb72a;
"use strict";
var $affee43d05afb4fc$var$bundleURL = {};
function $affee43d05afb4fc$var$getBundleURLCached(id) {
    var value = $affee43d05afb4fc$var$bundleURL[id];
    if (!value) {
        value = $affee43d05afb4fc$var$getBundleURL();
        $affee43d05afb4fc$var$bundleURL[id] = value;
    }
    return value;
}
function $affee43d05afb4fc$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $affee43d05afb4fc$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $affee43d05afb4fc$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $affee43d05afb4fc$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$affee43d05afb4fc$export$bdfd709ae4826697 = $affee43d05afb4fc$var$getBundleURLCached;
$affee43d05afb4fc$export$c9e73fbda7da57b6 = $affee43d05afb4fc$var$getBaseURL;
$affee43d05afb4fc$export$5a759dc7a1cfb72a = $affee43d05afb4fc$var$getOrigin;

});

var $5334f219377364d1$exports = {};


(parcelRequire("2evKT")).register((parcelRequire("f6OTe")).getBundleURL("lYbF2"), JSON.parse('["lYbF2","index.da33ca71.js","eW5wL","caret-down.68d4cd16.svg","5RGAp","de.cd11a45f.js","3uTpJ","es.ba06aaff.js","4XbAZ","fi.7629ab8b.js","2bKIP","fr.8783c9d5.js","i0BNf","hu.89de6ca3.js","98Cvg","id.54e3fe29.js","y5edP","ja.0e606fe2.js","9fDFY","jv.92ba8478.js","cW2nR","ko.d8e6b1c3.js","8ucza","lv.ee5d3af5.js","f3RKT","nl.1402c478.js","fVlhe","pt-BR.988d347f.js","kcBSP","ru.df09d0e3.js","4RByM","su.e63fd71f.js","ap9yw","sv.2e7effd2.js","dsJ3g","zh-CN.dac2191e.js","lF1Tu","zh-TW.71abe7bc.js","hWwEP","cancel.5edb67d5.svg","83Fnk","check.42e17e77.svg","1twgF","remove-layer.4e9b2b7d.svg","h8ubb","brush-pressure.f4437531.svg","htADd","copy.4adadd0c.svg","ffKNP","tool-picker.d0e69c3a.svg","iqIgb","angle.f0b557ac.svg","jYhj7","tool-zoom-in.d413f042.svg","44EC1","tool-zoom-out.299f4d1f.svg","9Kabf","viewport-reset.25476ab5.svg","b30IN","tool-hand.e7fc81b9.svg","8fN0r","edit-pencil.d7636d97.svg","fduLu","edit-crop.16c534dd.svg","70WHw","add-layer.ce1078bb.svg","3huo1","duplicate-layer.3314e3c7.svg","1AvFX","merge-layers.19da79a6.svg","ftA1L","rename-layer.7c31d4f4.svg","fcdZI","cursor-rotate.4dea8425.png","6Sfz2","klecks-logo.2dcce02e.png","eaJmh","new-image.2d692480.svg","kV8IH","import.7a68c844.svg","SROeX","export.2deb9ff8.svg","lFrok","share.454898d1.svg","cvYlU","help.208e9032.svg","dW3eU","tool-paint.f73a8943.svg","fnumN","tool-fill.3358320a.svg","6J8A8","tool-gradient.64486254.svg","da34V","tool-text.1cbd0325.svg","eStsa","tool-shape.3de78c3f.svg","cJJU9","tool-select.bd971ee9.svg","1YnIA","tool-undo.9138898d.svg","8l03e","edit-rotate.fd0e572a.svg","8K12o","ui-collapse.2b5dfc6a.svg","2WSh2","align-left.4876a845.svg","lHK8L","align-center.6f56d4bd.svg","3kjmQ","align-right.1521d61c.svg","g8nvA","typo-italic.7ab32910.svg","axEKL","typo-bold.5c790c89.svg","hapKl","Caveat-Regular.2fe80bbd.woff2","dqzux","ClimateCrisis-Regular-VariableFont_YEAR.3ad02523.woff2","l7VGL","CorrectionBrush.a69973aa.woff2","dm0T7","DancingScript-Regular.ef2fe647.woff2","2U3dq","Diabolik-Regular-VF.f4eeb79e.woff2","axzlU","FreckleFace-Regular.05946539.woff2","avgh6","Gloock-Regular.60f8f765.woff2","H9bSu","Pacha.08c8457a.woff2","emBfm","GochiHand-Regular.c45792b0.woff2","kjRvm","PassionOne-Bold.9e08b0dc.woff2","c79R0","PixeloidSans.bc292131.woff2","fndWQ","PlaypenSans-Thin.314b29a4.woff2","iAFmc","Quicksand-Light.1f0c44a2.woff2","2Bq6W","Silkscreen-Regular.cef2b4cb.woff2","hmfbp","Tehroc-Regular.4540047b.woff2","iItsG","YUNGA-Display.30c04a15.woff2","7tOPd","edit-brightness-contrast.8430cb26.svg","ijSd4","edit-curves.bbdb97b2.svg","3lCpH","edit-flip.00fd2c6b.svg","hhylW","edit-hue-saturation.6e36cf05.svg","kV0ed","edit-invert.f5d05ba3.png","dNk9L","edit-perspective.e23100db.svg","aj5Gc","edit-resize.56391e2b.svg","6D2tK","edit-tilt-shift.f8ae88b3.png","7nesm","edit-to-alpha.f7a2065a.svg","leHUT","edit-transform.c8795430.svg","3lP2j","edit-triangle-blur.d2c20f1d.png","7G4sY","edit-unsharp-mask.f1520547.png","7n1Rt","edit-grid.e900ce7b.svg","ijwf0","edit-noise.51bd751c.svg","18gIG","edit-pattern.1a06e094.svg","786LQ","edit-vanish-point.fc5858e4.svg","kcnOE","edit-distort.bdb643f2.svg","6218s","brush-pen.49a7b91e.svg","50oCU","brush-blend.3706e8a1.svg","jDYzC","brush-sketchy.4c477c01.png","j07R3","brush-pixel.673f3e4c.svg","fvqmo","brush-eraser.a9e10dce.svg","gNPk4","brush-smudge.45852bcd.svg","371uF","brush-chemy.a5a188f6.svg","gJzzT","upload.5289e924.svg","c3ZSC","loading.7ff8a2ac.gif","kNYzr","dist.56049e69.js","hTlU7","bitbof-logo.bc5e3ed5.svg","hxlHN","ui-swap-lr.7f474f51.svg","62mlz","licenses.fc8627f9.js","76QQo","font-licenses.0e2c26a4.js","c92cL","constrain.62f04e45.svg","kycpJ","tab-settings.980aa34c.svg","TzbtI","tab-layers.c8a104e7.svg","20qpJ","tab-edit.b0f2915c.svg","ayl5b","cursor-picker.dc155349.png","ixtEz","cursor-fill.999c4916.png","3iHbP","cursor-text.582bc0db.png","8Sx0P","cursor-zoom-ew.9ecaf1c2.png","ik9pg","select-mode-select.a497171d.svg","5L6w4","select-mode-move.3778aa02.svg","5EEMH","select-default.59c89a67.svg","7BIG2","select-union.89b92ea7.svg","lHffr","select-subtract.8960756d.svg","fNKMg","select-shape-rect.4ee8affe.svg","i03gc","select-shape-ellipse.2cdd0c2d.svg","5ldPc","select-shape-lasso.91ac9c84.svg","eJ7gT","select-shape-poly.8eed0bea.svg","37u58","index.ed827dd4.css"]'));

})();
//# sourceMappingURL=index.runtime.e3d31672.js.map
